export class SessionManager {
  clearUserSession () {
    localStorage.removeItem('token')
    // localStorage.removeItem('deviceId')
    // localStorage.removeItem('card')
    sessionStorage.removeItem('isLoggedIn')
    // localStorage.removeItem('uuid')
    localStorage.removeItem('user')
    sessionStorage.removeItem('logaToken')
    localStorage.removeItem('cardMenu')
    // sessionStorage.removeItem('card')
  }

  resetUserState () {
    console.log('resetUserState')
    // localStorage.removeItem('uuid')
    localStorage.removeItem('user')
    sessionStorage.removeItem('logaToken')
    localStorage.removeItem('cardMenu')
  }

  resetCardState () {
    console.log('resetCardState')
    localStorage.removeItem('user')
    localStorage.removeItem('cardMenu')
  }
}
